import React from "react";
import OverviewBlock from "./overviewBlock";

const Overview = (props) => {
  const { data, darkMode } = props;

  const renderIcon = (title) => {
    let iconClass = "icon ";

    switch (title) {
      case "facebook":
        iconClass += "icon-fb";
        break;
      case "instagram":
        iconClass += "icon-insta";
        break;
      case "twitter":
        iconClass += "icon-twtr";
        break;
      case "youtube":
        iconClass += "icon-yt";
        break;
      default:
    }
    return <i className={iconClass} />;
  };

  const renderValue = (value) => {
    if (value >= 10000) {
      return `${Math.floor(value / 1000)}k`;
    }
    return value;
  };

  const renderTrend = (lastValue, currentValue) => {
    const trend = Math.floor((currentValue / lastValue) * 100) - 100;
    let iconClass = "icon icon-up";
    let textClass = "up-color";
    iconClass = trend < 0 ? "icon icon-down" : iconClass;
    textClass = trend < 0 ? "down-color" : textClass;
    return (
      <React.Fragment>
        <i className={iconClass} />
        <span className={textClass}>{Math.abs(trend)}%</span>
      </React.Fragment>
    );
  };

  return (
    <div className="overview">
      {" "}
      <h2
        className={
          darkMode ? "dashboard_dark_maintext" : "dashboard_light_maintext"
        }>
        Overview - Today
      </h2>
      <div className="overview-grid">
        {" "}
        {data.map((elem) => (
          <OverviewBlock
            dataBlock={elem}
            darkMode={darkMode}
            renderIcon={renderIcon}
            renderValue={renderValue}
            renderTrend={renderTrend}
          />
        ))}
      </div>
    </div>
  );
};
export default Overview;
